/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Reason_In_AdjustmentInputs */

const vi_sl_new_reason_in_adjustment = /** @type {(inputs: Sl_New_Reason_In_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh`)
};

/**

* @param {Sl_New_Reason_In_AdjustmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_reason_in_adjustment = /** @type {((inputs?: Sl_New_Reason_In_AdjustmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Reason_In_AdjustmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_reason_in_adjustment(inputs)
});